module.exports = __webpack_public_path__ + "img/weights1.4847a10f.png";